import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';
import { CreditsPackage } from '../../model/classes/CreditsPackage';

export const PACKAGES_LIST_KEY = ['PACKAGES_LIST'] as const;

type PackagesResponse = {
  data: CreditsPackage[];
};

export const useGetAllPackages = (enabled = true) =>
  useQuery<CreditsPackage[]>({
    queryKey: PACKAGES_LIST_KEY,
    queryFn: async () => {
      const { data } = await axiosInstance.get<PackagesResponse>('api/credit-packages', {
        doNotAddUserTokenAuthorization: true
      } as any);

      return data.data;
    },
    staleTime: 1000,
    enabled
  });
